import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'artemis-add-screening-result-comment-dialog',
  templateUrl: './add-screening-result-comment-dialog.component.html',
  styleUrls: ['./add-screening-result-comment-dialog.component.scss']
})
export class AddScreeningResultCommentDialogComponent implements OnInit {

  @Output() commentToSubmit: EventEmitter<string> = new EventEmitter<string>();

  commentContent: string;

  constructor(private dialogRef: MatDialogRef<any>) { }

  ngOnInit() {
  }

  /**
   * Close modal for adding comment and clearing the text inside
   * @method closeAddCommentModal
   */
  closeAddCommentModal(): void {
    this.dialogRef.close();
  }

  /**
   * Save comment
   * @method saveComment
   */
  saveComment(): void {
    this.dialogRef.close(this.commentContent);
  }
}
